import { Interweave } from "interweave";
import React, { Fragment, useEffect, useState } from "react";
import { Carousel } from "react-bootstrap-v5";
import { useParams } from "react-router-dom";
import Footer from "../../components/footer";
import PageTitle from "../../components/pagetitle";
import Scrollbar from "../../components/scrollbar";

import {
    BASE_URL,
    GET_CONTENTS_BY_MENU_ID,
    GET_IMAGE_BY_MENU_ID,
    GET_MENUS_ALL_NESTED
} from "../../constant/constants";
  
  function items(obj) {
    let content = [];
  
    // eslint-disable-next-line no-unused-vars
    for (let key in obj) {
      let contentItem = {};
      let objs = obj;
  
      contentItem[`${key}`] = objs[key];
      content.push(contentItem);
    }
    return content;
  }

const BlogPageFullwidth =(props) => {

    
  const { id } = useParams();
  const [contents, setContents] = useState("");
  const [contentsImage, setContentsImage] = useState("");
  const [menuContent, setMenuContent] = useState({});
  const [homeId, setHomeId] = useState();

//   useEffect(() => {
//     fetch(`${GET_CONTENTS_BY_MENU_ID}/${id}`)
//       .then((response) => response.json())
//       .then((data) => {
//         setContents(data.menu_contents);

//         console.log("allmenucontent", data);
//       })
//       .catch(() => {});

//     fetch(`${GET_MENU_ITEM_BY_ID}/${id}`)
//       .then((response) => response.json())
//       .then((data) => {
//         setMenuContent(data);

//         console.log("allmenucontent", data);
//       })
//       .catch(() => {});
//     // Get Content Image
//     fetch(`${GET_IMAGE_BY_MENU_ID}/${id}`)
//       .then((response) => response.json())
//       .then((data) => {
//         setContentsImage(data.content_images);

//         console.log("imagesContent", data);
//       })
//       .catch(() => {});
//   }, [id]);

 useEffect(() => {
    fetch(`${GET_MENUS_ALL_NESTED}`)
      .then((response) => response.json())
      .then((data) => {
        data.menus.find((e) => (e.name === "Home" ? setHomeId(e.id) : null));
      })
      .catch(() => {});
  }, []);
    useEffect(() => {
      const fetchData = async () => {
        try {
          const imageResponse = await fetch(
            `${GET_IMAGE_BY_MENU_ID}/${homeId || id || props.id}`
          );
          const imageData = await imageResponse.json();
          setContentsImage(imageData.content_images);
          console.log("imagesContent", imageData);
  
          const contentResponse = await fetch(
            `${GET_CONTENTS_BY_MENU_ID}/${homeId || id || props.id}`
          );
          const contentData = await contentResponse.json();
          setMenuContent(contentData.menu_contents);
          console.log("allmenucontent", contentData.menu_contents);
        } catch (error) {
          console.error("Error fetching data:", error);
        }
      };
  
      fetchData();
    }, [id, homeId, props.id]);

  const newContents = items(contents);
  console.log("contents,contentsImage", newContents, contentsImage);
  console.log("menuContent", menuContent);
    return(
        <Fragment>

            <PageTitle pageTitle={menuContent?.name} pagesub={menuContent?.name} />
      <section className="wpo-project-single-section section-padding">
        <div className="container">
          <div className="row">
          <div className="col-lg-10 offset-lg-1">
  <div className="wpo-project-single-wrap">
    <div className="wpo-project-single-content">
      <div className="container-fluid">
        {/* Render images from contentsImage */}
        {Object.entries(contentsImage || {}).map(([key, value]) => 
          key === "contentKey" && (
            <img
              key={key}
              style={{
                borderRadius: "2%",
                display: "block",
                maxHeight: "fit-content",
                marginLeft: "auto",
                marginRight: "auto",
              }}
              className="d-block w-100 mx-auto text-center rounded"
              src={`${BASE_URL}/media/${value}`}
              alt=""
            />
          )
        )}
      </div>
      <div className="wpo-project-single-content-des">
        <div className="wpo-project-single-content-des-wrap">
          {/* Left Section */}
          <div className="wpo-project-single-content-des-left">
            <h2>{menuContent?.menu_contents}</h2>
            <Interweave
              allowAttributes
              allowElements
              disableLineBreaks
              content={menuContent?.menu_contents}
            />
          </div>

          {/* Right Section */}
          <div className="wpo-project-single-content-des-right">
            {newContents.map((service, index) =>
              Object.entries(service).map(
                ([contentKey, contentValue]) =>
                  contentKey === "Duration" && (
                    <div className="col-12" key={`${contentKey}-${index}`}>
                      <h2>{contentKey}</h2>
                      <Interweave
                        allowAttributes
                        allowElements
                        disableLineBreaks
                        content={contentValue}
                      />
                    </div>
                  )
              )
            )}
          </div>
        </div>

        {/* Carousel for Program Images */}
        <div>
          <Carousel fade>
            {Object.entries(contentsImage || {}).map(([key, value]) =>
              key === "Program Image" &&
              value.map((img, index) => (
                <Carousel.Item key={index}>
                  <img
                    className="d-block w-100 mx-auto text-center rounded"
                    height={400}
                    src={`${BASE_URL}/media/${img}`}
                    alt={`Slide ${index}`}
                  />
                </Carousel.Item>
              ))
            )}
          </Carousel>
        </div>
      </div>
    </div>

    {/* Benefits Section */}
    <div className="wpo-solutions-section">
      <div className="row">
        {newContents.map((service, index) =>
          Object.entries(service).map(
            ([contentKey, contentValue]) =>
              contentKey === "Program Benefits" && (
                <div className="col-12" key={`${contentKey}-${index}`}>
                  <h2>{contentKey}</h2>
                  <Interweave
                    allowAttributes
                    allowElements
                    disableLineBreaks
                    content={contentValue}
                  />
                </div>
              )
          )
        )}
      </div>
    </div>
  </div>
</div>

          </div>
        </div>
      </section>
      <Footer />
      <Scrollbar />
        </Fragment>
    )
};
export default BlogPageFullwidth;

